module.exports = __webpack_public_path__ + "img/WAZ.bd959dbc.svg";